// extracted by mini-css-extract-plugin
module.exports = {"fb_btn":"socialNetworkStyles_fb_btn__3zzon","apple_btn":"socialNetworkStyles_apple_btn__2D4E6"};